import { render, staticRenderFns } from "./DeletePresetDialog.vue?vue&type=template&id=a5a1feb4&scoped=true&"
import script from "./DeletePresetDialog.vue?vue&type=script&lang=js&"
export * from "./DeletePresetDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeletePresetDialog.vue?vue&type=style&index=0&id=a5a1feb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a1feb4",
  null
  
)

export default component.exports